import { useCallback, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import LoadingPartCM from "components/shared/PartLoading";
import { Link } from "react-router-dom";
import {
  StyledButtonsDiv,
  StyledMainWrapper,
  StyledCard,
  StyledTypography,
  StyledCardActions,
  StyledContainer,
  StyledSpan,
} from "./CommentButton.style";
import { Button } from "@mui/material";
import Modal from "components/shared/Modal";
import { Grid, TextField } from "@mui/material";
import { addCommentRequest, getCommentRequest } from "api/requests";
import { PAGINATION_LIMIT_5 } from "constants";
import Toast from "helper/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import { addCommentSchema } from "validations";
import useHttp from "hooks/use-http";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useAuth from "hooks/use-auth";
import { FaCommentDots } from "react-icons/fa";
import { MdInsertComment } from "react-icons/md";

export default function ShareButton() {
  const AuthCTX = useAuth();
  const params = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const { request, loading } = useHttp();
  const [messages, setMessages] = useState({ data: [], count: 0 });
  const [commenttitle, setCommentTitle] = useState("");
  const [commenttext, setCommentText] = useState("");
  const [page, setPage] = useState(1);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addCommentSchema),
  });

  const onSubmit = async (data) => {
    const res = await request({
      url: () => addCommentRequest({ ...data, product_id: params.productId }),
    });
    setIsOpen(false);
    if (res) {
      setCommentTitle("");
      setCommentText("");
      reset({
        description: "",
        title: "",
      });
      Toast({ type: "success", title: "ثبت نظر" });
    }
  };

  const getMessages = useCallback(async () => {
    const res = await request({
      url: getCommentRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT_5,
        limit: PAGINATION_LIMIT_5,
        product_id: params.productId,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.notification_id,
      user: items?.user?.full_name,
      title: items?.title,
      text: items?.text,
      date: items?.created_at?.string,
      is_seen: items.is_seen,
    }));

    setMessages({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getMessages();
  }, []);

  return (
    <>
      <StyledMainWrapper>
        {/* {!AuthCTX.isLoggedIn ? (
          ""
        ) : ( */}
        <Button onClick={() => setIsOpen(true)}>
          <FaCommentDots style={{ paddingLeft: "6px", fontSize: "27px" }} />
          ثبت دیدگاه
        </Button>
        {/* )} */}
        <CardContent style={{ padding: "5px" }}>
          {loading ? (
            <div style={{ textAlign: "center", padding: "28px" }}>
              <LoadingPartCM />
            </div>
          ) : messages.count == 0 ? (
            <div style={{ textAlign: "center", padding: "28px" }}>
              دیدگاهی یافت نشد
            </div>
          ) : (
            <StyledContainer pb={2} mt={2}>
              {messages.data.map((items, index) => (
                <StyledCard key={"card" + index}>
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 17 }}
                      color="#070937"
                      gutterBottom
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <StyledSpan>
                        <MdInsertComment />
                      </StyledSpan>
                      <span>{items?.title}</span>
                    </Typography>
                    <StyledTypography mt={2}>{items.text}</StyledTypography>
                  </CardContent>
                  <StyledCardActions style={{ direction: "ltr" }}>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      <span style={{ marginLeft: "30px" }}>{items.user}</span>{" "}
                      {items.date}
                    </Typography>
                  </StyledCardActions>
                </StyledCard>
              ))}
              <Grid container my={2} spacing={1}>
                <Grid item xs={12}>
                  <PaginationCM
                    handleChange={(e, val) => setPage(val)}
                    page={page}
                    limit={PAGINATION_LIMIT_5}
                    count={messages.count}
                  />
                </Grid>
              </Grid>
            </StyledContainer>
          )}
        </CardContent>
      </StyledMainWrapper>

      <Modal show={isOpen} onClose={() => setIsOpen(false)} title="دیدگاه شما">
        <StyledButtonsDiv>
          {!AuthCTX.isLoggedIn ? (
            <>
              <p className="text">
                لطفا برای ثبت دیدگاه وارد حساب کاربری خود شوید.
              </p>
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <Link to={`/login`}>
                  <Button variant="outlined">
                    <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                      ورود به حساب کاربری
                    </span>
                  </Button>
                </Link>
              </div>
            </>
          ) : (
            <>
              <p className="text">
                دیگران را با نوشتن نظرات خود، برای انتخاب این محصول راهنمایی
                کنید.
              </p>
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    id="title"
                    label="عنوان نظر"
                    fullWidth
                    size="small"
                    {...register("title")}
                    error={Boolean(errors["title"])}
                    helperText={errors["title"]?.message}
                    style={{ width: "100%", overflow: "visible" }}
                    onChange={(e) => setCommentTitle(e.target.value)}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    id="description"
                    label="متن نظر"
                    fullWidth
                    multiline
                    rows={3}
                    {...register("description")}
                    error={Boolean(errors["description"])}
                    helperText={errors["description"]?.message}
                    style={{ width: "100%", overflow: "visible" }}
                    onChange={(e) => setCommentText(e.target.value)}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit)}
                    fullWidth
                    style={{ height: "45px", marginTop: "12px" }}
                    disabled={
                      commenttitle.length < 3 ||
                      commenttext.length < 3 ||
                      loading
                        ? true
                        : false
                    }
                  >
                    {loading ? <LoadingPartCM /> : "ثبت دیدگاه"}
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </StyledButtonsDiv>
      </Modal>
    </>
  );
}
